import { render, staticRenderFns } from "./msgContBox.vue?vue&type=template&id=4e9cad12&scoped=true"
import script from "./msgContBox.vue?vue&type=script&lang=js"
export * from "./msgContBox.vue?vue&type=script&lang=js"
import style0 from "./msgContBox.vue?vue&type=style&index=0&id=4e9cad12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9cad12",
  null
  
)

export default component.exports